var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhiteVirtualTourGenricIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "white-virtual-tour-genric-icon_svg__a",
    d: "M0 0h13.676v14.165H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "white-virtual-tour-genric-icon_svg__c",
    d: "M0 0h14.096v14.6H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.838 1.666c-2.883 0-5.23 2.43-5.23 5.416s2.347 5.416 5.23 5.416c.295 0 .584-.026.865-.075l-.28-.73a4.185 4.185 0 01-.585.04c-2.477 0-4.491-2.087-4.491-4.65 0-2.565 2.014-4.652 4.49-4.652 2.352 0 4.285 1.881 4.476 4.264l.753.312c-.04-2.95-2.37-5.34-5.228-5.34",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "white-virtual-tour-genric-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#white-virtual-tour-genric-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.947 13.055c-.359.07-.73.11-1.109.11-3.239 0-5.873-2.728-5.873-6.083C.965 3.729 3.599 1 6.838 1c3.238 0 5.873 2.729 5.873 6.082 0 .064-.003.127-.005.19l.945.39c.015-.191.025-.384.025-.58C13.676 3.177 10.608 0 6.838 0 3.067 0 0 3.177 0 7.082c0 3.906 3.067 7.083 6.838 7.083.505 0 .998-.06 1.471-.168l-.362-.942z",
    fill: "#FFF",
    mask: "url(#white-virtual-tour-genric-icon_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.904 5.4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "white-virtual-tour-genric-icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#white-virtual-tour-genric-icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.643 13.03L7.769 9.017a.618.618 0 00-.526-.185.623.623 0 00-.463.32l-1.302 2.336-3.724-9.671 9.336 3.857-2.256 1.349a.666.666 0 00-.129 1.025l3.874 4.012-.936.97zm-1.471-5.304L12.84 6.13a.659.659 0 00.313-.611.65.65 0 00-.394-.557L.862.047A.614.614 0 00.184.19a.668.668 0 00-.14.702L4.79 13.216c.089.23.298.39.539.408a.624.624 0 00.589-.323l1.54-2.764 3.74 3.873a.613.613 0 00.889 0l1.825-1.89a.666.666 0 000-.92l-3.74-3.874z",
    fill: "#FFF",
    mask: "url(#white-virtual-tour-genric-icon_svg__d)"
  })))));
}

export default SvgWhiteVirtualTourGenricIcon;